import { Routing, RoutingPages } from '@models/routing.model';
import { Landingpages } from './landingpages';

/* Resolvers */
import { blogResolver } from '@resolvers/blog.resolver';
import { blogArticleResolver } from '@resolvers/blog-article.resolver';
import { carAaaidRevoler } from '@resolvers/car-aaaid.resolver';
import { carValuationDetailResolver } from '@resolvers/car-valuation-detail.resolver';
import { contactCardsResolver } from '@resolvers/contact-cards.resolver';
import { detailResolver } from '@resolvers/detail.resolver';
import { financingFormResolver } from '@resolvers/financing-form.resolver';
import { listResolver } from '@resolvers/list.resolver';
import { onlineFormResolver } from '@resolvers/online-form.resolver';

/* Guards */
import { carValuationGuard } from '@guards/car-valuation.guard';
import { partnersResolver } from '@resolvers/partners.resolver';

const RoutingData: Routing = {
  webTitle: { cs: 'Mototechna.cz' },
  defaultTitle: { cs: '' },
  defaultDescription: {
    cs: 'Hledáte auta na splátky s flexibilními podmínkami? Získejte své vysněné auto rychle a snadno díky našemu výhodnému financování aut.',
  },
  pageTypeDefault: 'Articles',
  pages: [
    {
      id: 'list',
      url: { cs: 'prodej-vozu' },
      pageType: 'Category',
      loadComponent: () => import('@pages/list/list.component').then(m => m.ListPageComponent),
      title: { cs: 'Široká nabídka aut na splátky' },
      description: { cs: 'Auta na splátky za nejvýhodnější ceny. Získejte své vysněné auto rychle a snadno díky našemu výhodnému financování aut.' },
      numberOfParams: 6,
      paramsTitle: { cs: 'custom' },
      paramsDescription: { cs: 'custom' },
      resolve: {
        data: listResolver,
      },
    },
    {
      id: 'detail',
      url: { cs: 'detail/:make/:model/:id' },
      loadComponent: () => import('@pages/detail/detail.component').then(m => m.DetailPageComponent),
      pageType: 'Product',
      resolve: {
        data: detailResolver,
        contactCards: contactCardsResolver,
        partners: partnersResolver,
      },
    },
    {
      id: 'carAaaid',
      url: { cs: 'car' },
      loadComponent: () => import('@pages/car-aaaid/car-aaaid.component').then(m => m.CarAaaidComponent),
      routes: { cs: ['car/:id'] },
      resolve: {
        data: carAaaidRevoler,
      },
    },
    {
      id: 'notFound',
      url: { cs: '404' },
      pageType: '404',
      loadComponent: () => import('@pages/not-found/not-found.component').then(m => m.NotFoundPageComponent),
      title: { cs: 'Stránka nenalezena' },
      description: { cs: 'Stránka nenalezena' },
    },
    {
      id: 'formThanks',
      type: 'forms',
      pageType: 'Purchase',
      url: { cs: 'formular-odeslan' },
      loadComponent: () => import('@pages/financing-form/form-thanks/financing-form-thanks.component').then(m => m.FormThanksPageComponent),
      title: { cs: 'Formulář byl úspěšně odeslán' },
      description: { cs: 'Děkujeme, formulář byl úspěšně odeslán.' },
    },
    {
      id: 'financingForm',
      type: 'forms',
      pageType: 'Form',
      url: { cs: 'nabidka-financovani' },
      redirectTo: { cs: 'nabidka-financovani/kalkulacka' },
    },
    {
      id: 'financingFormCalculator',
      type: 'forms',
      pageType: 'Form',
      url: { cs: 'nabidka-financovani/kalkulacka' },
      loadComponent: () => import('@pages/financing-form/financing-form-calculator/financing-form-calculator.component').then(m => m.FinancingFormCalculatorPageComponent),
      title: { cs: 'Financování vozu snadno a online' },
      description: { cs: 'Vyřešte nákup vozu na financování s online předschválením' },
      resolve: {
        data: financingFormResolver,
      },
      data: { type: 'products' },
    },
    {
      id: 'financingFormProducts',
      type: 'forms',
      pageType: 'Form',
      url: { cs: 'nabidka-financovani/partneri' },
      loadComponent: () => import('@pages/financing-form/financing-form-products/financing-form-products.component').then(m => m.FinancingFormProductsPageComponent),
      title: { cs: 'Financování vozu snadno a online' },
      description: { cs: 'Vyřešte nákup vozu na financování s online předschválením' },
      resolve: {
        data: financingFormResolver,
      },
      data: { type: 'products' },
    },
    {
      id: 'financingFormContactInformations',
      type: 'forms',
      pageType: 'Form',
      url: { cs: 'nabidka-financovani/kontaktni-udaje' },
      loadComponent: () => import('@pages/financing-form/financing-form-contact-informations/financing-form-contact-informations.component').then(m => m.FinancingFormContactInformationsPageComponent),
      title: { cs: 'Financování vozu snadno a online' },
      description: { cs: 'Vyřešte nákup vozu na financování s online předschválením' },
      resolve: {
        data: financingFormResolver,
      },
      data: { type: 'contact-form' },
    },
    {
      id: 'financingFormSavedForm',
      type: 'forms',
      pageType: 'Form',
      url: { cs: 'nabidka-financovani/ulozeny-formular' },
      loadComponent: () => import('@pages/financing-form/financing-form-saved/financing-form-saved.component').then(m => m.FinancingFormSavedPageComponent),
      title: { cs: 'Financování vozu snadno a online' },
      description: { cs: 'Vyřešte nákup vozu na financování s online předschválením' },
    },
    {
      id: 'carValuation',
      type: 'forms',
      pageType: 'Form',
      url: { cs: 'oceneni-vozu' },
      redirectTo: { cs: 'oceneni-vozu/specifikace-vozu' },
    },
    {
      id: 'carValuationSpecification',
      type: 'forms',
      url: { cs: 'oceneni-vozu/specifikace-vozu' },
      loadComponent: () => import('@pages/car-valuation/car-valuation-specification/car-valuation-specification.component').then(m => m.CarValuationSpecificationPageComponent),
      title: { cs: 'Ocenění vozu - Specifikace vozu' },
      description: { cs: 'Ocenění vozu - Specifikace vozu' },
      pageType: 'Form',
    },
    {
      id: 'carValuationEquipment',
      type: 'forms',
      url: { cs: 'oceneni-vozu/vybava' },
      loadComponent: () => import('@pages/car-valuation/car-valuation-equipment/car-valuation-equipment.component').then(m => m.CarValuationEquipmentPageComponent),
      title: { cs: 'Ocenění vozu - Výbava' },
      description: { cs: 'Ocenění vozu - Výbava' },
      pageType: 'Form',
      canActivate: [carValuationGuard],
    },
    {
      id: 'carValuationCondition',
      type: 'forms',
      url: { cs: 'oceneni-vozu/stav-auta' },
      loadComponent: () => import('@pages/car-valuation/car-valuation-condition/car-valuation-condition.component').then(m => m.CarValuationConditionPageComponent),
      title: { cs: 'Ocenění vozu - Stav auta' },
      description: { cs: 'Ocenění vozu - Stav auta' },
      pageType: 'Form',
      canActivate: [carValuationGuard],
    },
    {
      id: 'carValuationPhotos',
      type: 'forms',
      url: { cs: 'oceneni-vozu/fotografie' },
      loadComponent: () => import('@pages/car-valuation/car-valuation-photo/car-valuation-photo.component').then(m => m.CarValuationPhotoPageComponent),
      title: { cs: 'Ocenění vozu - Fotografie' },
      description: { cs: 'Ocenění vozu - Fotografie' },
      pageType: 'Form',
      canActivate: [carValuationGuard],
    },
    {
      id: 'carValuationContactInformations',
      type: 'forms',
      url: { cs: 'oceneni-vozu/kontaktni-udaje' },
      loadComponent: () => import('@pages/car-valuation/car-valuation-contact-informations/car-valuation-contact-informations.component').then(m => m.CarValuationContactInformationsPageComponent),
      title: { cs: 'Ocenění vozu - Kontaktní údaje' },
      description: { cs: 'Ocenění vozu - Kontaktní údaje' },
      pageType: 'Form',
      canActivate: [carValuationGuard],
    },
    {
      id: 'carValuationDetail',
      type: 'forms',
      url: { cs: 'oceneni-vozu/detail-objednavky' },
      loadComponent: () => import('@pages/car-valuation/car-valuation-detail/car-valuation-detail.component').then(m => m.CarValuationDetailPageComponent),
      title: { cs: 'Ocenění vozu - Kontaktní údaje' },
      description: { cs: 'Ocenění vozu - Kontaktní údaje' },
      pageType: 'Form',
      resolve: {
        data: carValuationDetailResolver,
      },
    },
    {
      id: 'onlineForm',
      type: 'forms',
      pageType: 'Form',
      url: { cs: 'online-prodej' },
      redirectTo: { cs: 'online-prodej/zpusob-platby' },
    },
    {
      id: 'onlineFormPaymentOption',
      type: 'forms',
      url: { cs: 'online-prodej/zpusob-platby' },
      loadComponent: () => import('@pages/online-form/online-form-payment-option/online-form-payment-option.component').then(m => m.OnlineFormPaymentOptionPageComponent),
      title: { cs: 'Prodej vozu - Způsob platby' },
      description: { cs: 'Prodej vozu - Způsob platby' },
      pageType: 'Form',
      resolve: {
        data: onlineFormResolver,
      },
    },
    {
      id: 'onlineFormDeliveryType',
      type: 'forms',
      url: { cs: 'online-prodej/dodani-vozu' },
      loadComponent: () => import('@pages/online-form/online-form-delivery-type/online-form-delivery-type.component').then(m => m.OnlineFormDeliveryTypePageComponent),
      title: { cs: 'Prodej vozu - Dodání vozu' },
      description: { cs: 'Prodej vozu - Dodání vozu' },
      pageType: 'Form',
      resolve: {
        data: onlineFormResolver,
      },
    },
    {
      id: 'onlineFormAccessories',
      type: 'forms',
      url: { cs: 'online-prodej/prislusenstvi' },
      loadComponent: () => import('@pages/online-form/online-form-accessories/online-form-accessories.component').then(m => m.OnlineFormAccessoriesPageComponent),
      title: { cs: 'Prodej vozu - Příslušenství' },
      description: { cs: 'Prodej vozu - Příslušenství' },
      pageType: 'Form',
      resolve: {
        data: onlineFormResolver,
      },
    },
    {
      id: 'onlineFormContactInformations',
      type: 'forms',
      url: { cs: 'online-prodej/kontaktni-udaje' },
      loadComponent: () => import('@pages/online-form/online-form-contact-informations/online-form-contact-informations.component').then(m => m.OnlineFormContactInformationsPageComponent),
      title: { cs: 'Prodej vozu - Kontaktní údaje' },
      description: { cs: 'Prodej vozu - Kontaktní údaje' },
      pageType: 'Form',
      resolve: {
        data: onlineFormResolver,
      },
    },
    {
      id: 'blog',
      title: { cs: 'Blog' },
      url: { cs: 'blog' },
      loadComponent: () => import('@pages/blog/blog.component').then(m => m.BlogComponent),
      resolve: {
        data: blogResolver,
      },
    },
    {
      id: 'blogArticle',
      url: { cs: 'blog/:title/:id' },
      loadComponent: () => import('@pages/blog-article/blog-article.component').then(m => m.BlogArticleComponent),
      resolve: {
        data: blogArticleResolver,
      },
    },
    {
      id: 'reviews',
      title: { cs: 'Recenze' },
      url: { cs: 'recenze' },
      loadComponent: () => import('@pages/blog/blog.component').then(m => m.BlogComponent),
      data: { type: 'reviews' },
      resolve: {
        data: blogResolver,
      },
    },
    {
      id: 'reviewsArticle',
      url: { cs: 'recenze/:title/:id' },
      loadComponent: () => import('@pages/blog-article/blog-article.component').then(m => m.BlogArticleComponent),
      resolve: {
        data: blogArticleResolver,
      },
    },
    {
      id: 'urlShortener',
      url: { cs: 'url-shortener' },
      pageType: 'UrlShortener',
      loadComponent: () => import('@pages/url-shortener/url-shortener.component').then(m => m.UrlShortenerPageComponent),
    },
  ],
};

const landingPages = Landingpages;
RoutingData.pages = RoutingData.pages.concat(landingPages as RoutingPages[]);


export { RoutingData };
